module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "profile"
  }, [(_vm.toggleSpinner) ? _c('spinner', {
    staticClass: "pink",
    attrs: {
      "size": "lg",
      "fixed": "",
      "text": _vm.spinnerText
    },
    model: {
      value: (_vm.toggleSpinner),
      callback: function($$v) {
        _vm.toggleSpinner = $$v
      },
      expression: "toggleSpinner"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "tabs-content"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h3', {
    staticClass: "heading"
  }, [_c('svg', {
    attrs: {
      "width": "47px",
      "height": "48px",
      "viewBox": "0 0 47 48",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('title', [_vm._v("Work")]), _vm._v(" "), _c('desc', [_vm._v("Created with Sketch.")]), _vm._v(" "), _c('defs'), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Group-1",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "01_Tone_Home_Unauthenticated",
      "transform": "translate(-666.000000, -819.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Group-7",
      "transform": "translate(88.000000, 800.000000)"
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Work",
      "transform": "translate(666.000000, 819.000000)",
      "fill": _vm.getCorpHeaderColor
    }
  }, [_c('path', {
    attrs: {
      "d": "M45.6944444,-1.62630326e-19 C34.1361,-1.62630326e-19 23.4467333,5.0007033 15.9565,13.1868132 L1.30555556,13.1868132 C0.777223333,13.1868132 0.301896667,13.5082444 0.0999533333,14.0007033 C-0.102000444,14.4931464 0.0101937778,15.0597626 0.383504333,15.4368527 L8.84924878,23.9877099 C7.97410878,25.934822 7.23772322,27.964378 6.66651656,30.0742154 C6.54208144,30.5316343 6.67059511,31.0199736 7.00310444,31.3537582 L15.9566044,40.3988571 C16.2054747,40.6502295 16.5379944,40.78416 16.8806767,40.78416 C16.9949128,40.78416 17.1111908,40.7697389 17.2254269,40.7367719 C19.3143158,40.1598224 21.3257069,39.4160334 23.2513491,38.5320949 L31.7170936,47.082951 C31.9659638,47.3384482 32.3005202,47.4723735 32.6391291,47.4723735 C32.8064021,47.4723735 32.9777589,47.4394064 33.1389114,47.3714099 C33.6264529,47.1674258 33.9447003,46.6873308 33.9447003,46.1536869 L33.9447003,31.3554462 C42.0495892,23.7893802 47.0002559,12.9930725 47.0002559,1.31852308 C47.0002559,0.589134066 46.4168292,-0.000158241758 45.6947003,-0.000158241758 L45.6944444,-1.62630326e-19 Z M17.2599667,37.9864615 L9.39216667,30.0395604 C12.5765211,19.1398681 20.3483889,10.4882637 30.2074222,6.00474725 L41.0576333,16.9619341 C36.6167078,26.9200879 28.0532556,34.7725714 17.2599667,37.9864615 Z M44.3664333,2.66004396 C44.2256788,6.70881758 43.4484711,10.6275165 42.12657,14.3098022 L32.8325811,4.92448352 C36.4759167,3.58934505 40.3578033,2.80225055 44.3663811,2.66004396 L44.3664333,2.66004396 Z M4.45716667,15.8241758 L13.7407111,15.8241758 C12.3719144,17.5982242 11.1438567,19.4958593 10.0749722,21.4987253 L4.45716667,15.8241758 Z M31.3333333,42.9705495 L25.7152667,37.296 C27.6980922,36.2142593 29.5748022,34.9739077 31.3333333,33.5934066 L31.3333333,42.9705495 Z",
      "id": "Fill-1"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M1.30555556,47.4725275 C1.64010156,47.4725275 1.97462667,47.3447789 2.22962778,47.0872246 L7.45185,41.8124993 C7.96183133,41.2973908 7.96183133,40.4629081 7.45185,39.9477785 C6.94186867,39.4326699 6.11569222,39.4326699 5.60569,39.9477785 L0.383467778,45.2225037 C-0.126513556,45.7376123 -0.126513556,46.5720949 0.383467778,47.0872246 C0.636421778,47.3447789 0.970967778,47.4725275 1.30550333,47.4725275 L1.30555556,47.4725275 Z",
      "id": "Fill-2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M6.909,47.0874709 C7.16399067,47.3450252 7.49853667,47.4727738 7.83307222,47.4727738 C8.16760778,47.4727738 8.50214333,47.3450252 8.75714444,47.0874709 L12.6738111,43.1314286 C13.1837924,42.61632 13.1837924,41.7818374 12.6738111,41.2667077 C12.1638298,40.7515991 11.3376533,40.7515991 10.8276511,41.2667077 L6.91098444,45.2227501 C6.40100311,45.7358015 6.40100311,46.5723407 6.90894256,47.0874709 L6.909,47.0874709 Z",
      "id": "Fill-3"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M1.30555556,40.8791209 C1.64010156,40.8791209 1.97462667,40.7513723 2.22962778,40.493818 L6.14629444,36.5377741 C6.65627578,36.0226655 6.65627578,35.1881829 6.14629444,34.6730532 C5.63631311,34.1579446 4.81013667,34.1579446 4.30013444,34.6730532 L0.383467778,38.6290971 C-0.126513556,39.1442057 -0.126513556,39.9786884 0.383467778,40.493818 C0.636421778,40.7513723 0.970967778,40.8791209 1.30550333,40.8791209 L1.30555556,40.8791209 Z",
      "id": "Fill-4"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M26.1111111,14.5054945 C22.51065,14.5054945 19.5833333,17.4622418 19.5833333,21.0989011 C19.5833333,24.7355604 22.51065,27.6923077 26.1111111,27.6923077 C29.7115722,27.6923077 32.6388889,24.7355604 32.6388889,21.0989011 C32.6388889,17.4622418 29.7115722,14.5054945 26.1111111,14.5054945 Z M26.1111111,25.0549451 C23.9508344,25.0549451 22.1944444,23.2808967 22.1944444,21.0989011 C22.1944444,18.9169055 23.9508344,17.1428571 26.1111111,17.1428571 C28.2713878,17.1428571 30.0277778,18.9169055 30.0277778,21.0989011 C30.0277778,23.2808967 28.2713878,25.0549451 26.1111111,25.0549451 Z",
      "id": "Fill-5"
    }
  })])])])]), _vm._v(" "), _c('br'), _c('span', {
    style: ({
      color: _vm.getCorpHeadingColor
    })
  }, [_vm._v("Work")])])]), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [(_vm.getVideoSubcategories) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "interest-container work"
  }, [_c('button-group', {
    model: {
      value: (_vm.interestIndexes),
      callback: function($$v) {
        _vm.interestIndexes = $$v
      },
      expression: "interestIndexes"
    }
  }, _vm._l((_vm.getVideoSubcategories), function(interest, interestSubCategoryId) {
    return _c('checkbox', {
      key: interest.interestSubCategoryName.toString().toUpperCase(),
      staticClass: "min-padding checkbox-btn",
      style: (_vm.styleInterestObject(interest.interestSubCategoryName.toString().toUpperCase())),
      attrs: {
        "true-value": interest.interestSubCategoryName.toString().toUpperCase()
      }
    }, [_vm._v("\n                                        " + _vm._s(interest.interestSubCategoryName) + "\n                                    ")])
  }), 1)], 1)]), _vm._v(" "), (_vm.getAuthWorkVideos && _vm.getAuthWorkVideos.length >= 100 && !_vm.showAllVideosFlag) ? _c('a', {
    staticClass: "bolder hidemobile",
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.showAllVideos('top')
      }
    }
  }, [_vm._v("choose a category or click to see more")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "tabContent",
    class: {
      current: true
    },
    attrs: {
      "id": "tabs-1"
    }
  }, [(_vm.hideCompleteList() && !_vm.isMobile) ? _c('div', [_c('div', {
    staticClass: "row yourFaves"
  }, [_c('div', {
    staticClass: "col-md-12"
  }), _vm._v(" "), _vm._l((_vm.getAuthWorkVideos), function(video, index) {
    return ((index + 1) <= 99) ? _c('div', {
      staticClass: "col-xs-12 col-sm-6 col-md-4 bottom-margin",
      class: {
        'innerimggray': _vm.getTrialDays < 0
      }
    }, [_c('a', {
      staticClass: "nounderline",
      class: {
        'private-contents': video.isPrivate === '1'
      },
      attrs: {
        "href": '/watch/' + video.mediaid + '/' + video.title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()
      }
    }, [_c('div', {
      staticClass: "image-container"
    }, [_c('img', {
      staticClass: "jw-img-1",
      attrs: {
        "src": video.image,
        "alt": video.title,
        "title": video.title
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "text-wrap-title-1 align-to-bottom cursor"
    }, [_vm._v(_vm._s(_vm.formattedDuration(video.duration)))])]), _vm._v(" "), _c('p', {
      staticClass: "text-wrap-title cursor",
      attrs: {
        "title": video.title
      }
    }, [_c('i', {
      staticClass: "fa fa-play-circle-o"
    }), _vm._v(" " + _vm._s(video.title))])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
      staticClass: "plusicon btn-group"
    }, [_c('button', {
      staticClass: "dropdown-toggle ellipsis pull-right",
      attrs: {
        "title": "Add to Playlist",
        "id": video.mediaid,
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.showPlaylistMenu(video.mediaid)
        }
      }
    }, [_c('svg', {
      attrs: {
        "version": "1.1",
        "id": "Layer_1",
        "xmlns": "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        "x": "0px",
        "y": "0px",
        "width": "37px",
        "height": "24px",
        "viewBox": "0 0 37 24",
        "enable-background": "new 0 0 37 24",
        "xml:space": "preserve"
      }
    }, [_c('rect', {
      attrs: {
        "y": "0.2",
        "fill": _vm.getCorpHeaderColor,
        "width": "25",
        "height": "3"
      }
    }), _vm._v(" "), _c('rect', {
      attrs: {
        "y": "8.2",
        "fill": _vm.getCorpHeaderColor,
        "width": "25",
        "height": "3"
      }
    }), _vm._v(" "), _c('rect', {
      attrs: {
        "y": "17.2",
        "fill": _vm.getCorpHeaderColor,
        "width": "18.2",
        "height": "3"
      }
    }), _vm._v(" "), _c('rect', {
      attrs: {
        "x": "23",
        "y": "15.2",
        "fill": _vm.getCorpHeaderColor,
        "width": "14",
        "height": "4"
      }
    }), _vm._v(" "), _c('rect', {
      attrs: {
        "x": "27.958",
        "y": "10.242",
        "fill": _vm.getCorpHeaderColor,
        "width": "4",
        "height": "13.917"
      }
    })])]), _vm._v(" "), _c('ul', {
      staticClass: "hide"
    }, [(_vm.getUserPlaylists) ? _c('li', [_vm._m(0, true)]) : _vm._e(), _vm._v(" "), (_vm.getUserPlaylists) ? _c('li', {
      staticClass: "divider",
      attrs: {
        "role": "separator"
      }
    }) : _vm._e(), _vm._v(" "), _vm._l((_vm.getUserPlaylists), function(playlist) {
      return (_vm.getUserPlaylists) ? _c('li', [_c('label', {
        staticClass: "notificationwithcheckboxes"
      }, [_c('input', {
        attrs: {
          "type": "checkbox"
        },
        domProps: {
          "checked": _vm.verifyVideoExists(playlist, video)
        },
        on: {
          "click": function($event) {
            _vm.setPlaylistVideoStatus(video, playlist, _vm.verifyVideoExists(playlist, video))
          }
        }
      }), _vm._v(" " + _vm._s(playlist.title) + "\n                                                        "), _c('transition', {
        attrs: {
          "name": "fade"
        }
      }, [(video.mediaid === _vm.selectedVideo && playlist.playlistId === _vm.selectedPlaylist && _vm.videoAdded) ? _c('span', {
        staticClass: "added"
      }, [_vm._v("Added")]) : _vm._e()]), _vm._v(" "), _c('transition', {
        attrs: {
          "name": "fade"
        }
      }, [(video.mediaid === _vm.selectedVideo && playlist.playlistId === _vm.selectedPlaylist && _vm.videoRemoved) ? _c('span', {
        staticClass: "removed"
      }, [_vm._v("Removed")]) : _vm._e()])], 1)]) : _vm._e()
    }), _vm._v(" "), (_vm.getUserPlaylists) ? _c('li', {
      staticClass: "divider",
      attrs: {
        "role": "separator"
      }
    }) : _vm._e(), _vm._v(" "), _vm._m(1, true), _vm._v(" "), _c('li', [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.newPlaylistName),
        expression: "newPlaylistName"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (_vm.newPlaylistName)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.newPlaylistName = $event.target.value
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-plus-circle",
      attrs: {
        "title": "Insert New Playlist"
      },
      on: {
        "click": _vm.addNewPlayList
      }
    })])])], 2), _vm._v(" "), _c('div', {
      staticClass: "backdropformenu",
      on: {
        "click": function($event) {
          return _vm.hidePlaylistMenu(video.mediaid)
        }
      }
    })]), _vm._v(" "), _c('p', {
      staticClass: "right-heart-icon"
    }, [_c('a', {
      attrs: {
        "href": "javascript:",
        "title": "Liked this video?"
      },
      on: {
        "click": function($event) {
          return _vm.setVideoStatus(video)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-2x fa-heart-o",
      class: {
        'activeIcons': _vm.getVideoStatus(video)
      },
      style: ({
        color: _vm.getCorpHeaderColor
      }),
      attrs: {
        "aria-hidden": "true"
      }
    })])])]) : _vm._e()
  }), _vm._v(" "), (_vm.getAuthWorkVideos && _vm.getAuthWorkVideos.length >= 100 && !_vm.showAllVideosFlag) ? _c('a', {
    staticClass: "bolder hidemobile",
    attrs: {
      "id": "btmLink",
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.showAllVideos()
      }
    }
  }, [_vm._v("click to browse all videos")]) : _vm._e()], 2)]) : _c('div', [_c('div', {
    staticClass: "row yourFaves"
  }, [_c('div', {
    staticClass: "col-md-12"
  }), _vm._v(" "), _vm._l((_vm.getAuthWorkVideos), function(video, index) {
    return _c('div', {
      staticClass: "col-xs-12 col-sm-6 col-md-4 bottom-margin",
      class: {
        'innerimggray': _vm.getTrialDays < 0
      }
    }, [_c('a', {
      staticClass: "nounderline",
      class: {
        'private-contents': video.isPrivate === '1'
      },
      attrs: {
        "href": '/watch/' + video.mediaid + '/' + video.title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()
      }
    }, [_c('div', {
      staticClass: "image-container"
    }, [_c('img', {
      staticClass: "jw-img-1",
      attrs: {
        "src": video.image,
        "alt": video.title,
        "title": video.title
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "text-wrap-title-1 align-to-bottom cursor"
    }, [_vm._v(_vm._s(_vm.formattedDuration(video.duration)))])]), _vm._v(" "), _c('p', {
      staticClass: "text-wrap-title cursor",
      attrs: {
        "title": video.title
      }
    }, [_c('i', {
      staticClass: "fa fa-play-circle-o"
    }), _vm._v(" " + _vm._s(video.title))])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
      staticClass: "plusicon btn-group"
    }, [_c('button', {
      staticClass: "dropdown-toggle ellipsis pull-right",
      attrs: {
        "title": "Add to Playlist",
        "id": video.mediaid,
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.showPlaylistMenu(video.mediaid)
        }
      }
    }, [_c('svg', {
      attrs: {
        "version": "1.1",
        "id": "Layer_1",
        "xmlns": "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        "x": "0px",
        "y": "0px",
        "width": "37px",
        "height": "24px",
        "viewBox": "0 0 37 24",
        "enable-background": "new 0 0 37 24",
        "xml:space": "preserve"
      }
    }, [_c('rect', {
      attrs: {
        "y": "0.2",
        "fill": _vm.getCorpHeaderColor,
        "width": "25",
        "height": "3"
      }
    }), _vm._v(" "), _c('rect', {
      attrs: {
        "y": "8.2",
        "fill": _vm.getCorpHeaderColor,
        "width": "25",
        "height": "3"
      }
    }), _vm._v(" "), _c('rect', {
      attrs: {
        "y": "17.2",
        "fill": _vm.getCorpHeaderColor,
        "width": "18.2",
        "height": "3"
      }
    }), _vm._v(" "), _c('rect', {
      attrs: {
        "x": "23",
        "y": "15.2",
        "fill": _vm.getCorpHeaderColor,
        "width": "14",
        "height": "4"
      }
    }), _vm._v(" "), _c('rect', {
      attrs: {
        "x": "27.958",
        "y": "10.242",
        "fill": _vm.getCorpHeaderColor,
        "width": "4",
        "height": "13.917"
      }
    })])]), _vm._v(" "), _c('ul', {
      staticClass: "hide"
    }, [(_vm.getUserPlaylists) ? _c('li', [_vm._m(2, true)]) : _vm._e(), _vm._v(" "), (_vm.getUserPlaylists) ? _c('li', {
      staticClass: "divider",
      attrs: {
        "role": "separator"
      }
    }) : _vm._e(), _vm._v(" "), _vm._l((_vm.getUserPlaylists), function(playlist) {
      return (_vm.getUserPlaylists) ? _c('li', [_c('label', {
        staticClass: "notificationwithcheckboxes"
      }, [_c('input', {
        attrs: {
          "type": "checkbox"
        },
        domProps: {
          "checked": _vm.verifyVideoExists(playlist, video)
        },
        on: {
          "click": function($event) {
            _vm.setPlaylistVideoStatus(video, playlist, _vm.verifyVideoExists(playlist, video))
          }
        }
      }), _vm._v(" " + _vm._s(playlist.title) + "\n                                                        "), _c('transition', {
        attrs: {
          "name": "fade"
        }
      }, [(video.mediaid === _vm.selectedVideo && playlist.playlistId === _vm.selectedPlaylist && _vm.videoAdded) ? _c('span', {
        staticClass: "added"
      }, [_vm._v("Added")]) : _vm._e()]), _vm._v(" "), _c('transition', {
        attrs: {
          "name": "fade"
        }
      }, [(video.mediaid === _vm.selectedVideo && playlist.playlistId === _vm.selectedPlaylist && _vm.videoRemoved) ? _c('span', {
        staticClass: "removed"
      }, [_vm._v("Removed")]) : _vm._e()])], 1)]) : _vm._e()
    }), _vm._v(" "), (_vm.getUserPlaylists) ? _c('li', {
      staticClass: "divider",
      attrs: {
        "role": "separator"
      }
    }) : _vm._e(), _vm._v(" "), _vm._m(3, true), _vm._v(" "), _c('li', [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.newPlaylistName),
        expression: "newPlaylistName"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (_vm.newPlaylistName)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.newPlaylistName = $event.target.value
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-plus-circle",
      attrs: {
        "title": "Insert New Playlist"
      },
      on: {
        "click": _vm.addNewPlayList
      }
    })])])], 2), _vm._v(" "), _c('div', {
      staticClass: "backdropformenu",
      on: {
        "click": function($event) {
          return _vm.hidePlaylistMenu(video.mediaid)
        }
      }
    })]), _vm._v(" "), _c('p', {
      staticClass: "right-heart-icon"
    }, [_c('a', {
      attrs: {
        "href": "javascript:",
        "title": "Liked this video?"
      },
      on: {
        "click": function($event) {
          return _vm.setVideoStatus(video)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-2x fa-heart-o",
      class: {
        'activeIcons': _vm.getVideoStatus(video)
      },
      style: ({
        color: _vm.getCorpHeaderColor
      }),
      attrs: {
        "aria-hidden": "true"
      }
    })])])])
  })], 2)])])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('b', [_vm._v(" Add to ...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('label', {
    staticStyle: {
      "color": "#f0617d"
    }
  }, [_vm._v("Create new playlist")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('b', [_vm._v(" Add to ...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('label', {
    staticStyle: {
      "color": "#f0617d"
    }
  }, [_vm._v("Create new playlist")])])
}]}


// WEBPACK FOOTER //
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cab8592e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"search":"pk_test_6pRNASCoBOKtIshFeQd4XMUh","replace":"pk_live_NgwNoBs3GAlrsSez07Zyh4Jc"}!./~/string-replace-loader?{"search":"https:/www1.dev-tonenetworks.com","replace":"https:/www.tonenetworks.com"}!./~/string-replace-loader?{"search":"https:/s3.amazonaws.com/tone-assets/app/navigation","replace":"https:/assets.tonenetworks.com/app/navigation"}!./~/string-replace-loader?{"search":"sandbox_2yn8x45w_k2v4j3d55x4gh6xz","replace":"production_6r7mxqgh_htw3nq9wp32w8h2x"}!./src/components/Work.vue